import { parseTeam } from '@shared/markdown';
export function canViewAllTasksInProject(user, projectId, sections) {
    if (user.role === 'admin')
        return true;
    if (user.role === 'manager') {
        const teamSection = sections[projectId]?.team ?? '';
        const teamMembers = parseTeam(teamSection);
        return teamMembers.some((m) => m.username === user.username);
    }
    return false;
}
export function filterTasksByRole(tasks, user, sections) {
    if (!user)
        return [];
    if (user.role === 'admin')
        return tasks;
    if (user.role === 'manager') {
        const projectIdsWithAccess = new Set();
        for (const task of tasks) {
            if (task.projectId && canViewAllTasksInProject(user, task.projectId, sections)) {
                projectIdsWithAccess.add(task.projectId);
            }
        }
        return tasks.filter((t) => t.assignee === `@${user.username}` ||
            (t.projectId && projectIdsWithAccess.has(t.projectId)));
    }
    return tasks.filter((t) => t.assignee === `@${user.username}`);
}
export function getAccessibleProjectIds(projects, user, tasks, sections) {
    if (!user)
        return new Set();
    if (user.role === 'admin') {
        return new Set(projects.map((p) => p.project_id));
    }
    const accessible = new Set();
    if (user.role === 'manager') {
        for (const project of projects) {
            if (canViewAllTasksInProject(user, project.project_id, sections)) {
                accessible.add(project.project_id);
            }
        }
    }
    // Users can always see projects that have their own tasks
    for (const task of tasks) {
        if (task.assignee === `@${user.username}` && task.projectId) {
            accessible.add(task.projectId);
        }
    }
    return accessible;
}
export function parseChangeLog(raw) {
    const entries = [];
    const lines = raw.split('\n');
    for (const line of lines) {
        if (line.startsWith('|') && !line.startsWith('|---') && !line.startsWith('| #')) {
            const cells = line
                .split('|')
                .map((c) => c.trim())
                .filter((c) => c);
            if (cells.length >= 6) {
                entries.push({
                    number: parseInt(cells[0], 10),
                    timestamp: cells[1],
                    user: cells[2],
                    action: cells[3],
                    target: cells[4],
                    details: cells[5],
                });
            }
        }
    }
    return entries;
}
//# sourceMappingURL=access-control.js.map